import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// --- App 1: ESCOLHA-VAGAS ---
const firebaseConfig = {
  apiKey: "AIzaSyA4HesP0cyivdVjERj_XP6WsuvMNDCOJHE",
  authDomain: "escolha-vagas.firebaseapp.com",
  projectId: "escolha-vagas",
  storageBucket: "escolha-vagas.firebasestorage.app",
  messagingSenderId: "62123516247",
  appId: "1:62123516247:web:a811967ffefa82cf9b1e12",
  measurementId: "G-LV3N8XKXCF",
};

// --- App 2: NOTAS-DB ---
const firebaseConfigNotas = {
  apiKey: "AIzaSyAOKh3HMQvwOeee-TE1w2uGJv7h6KbCgZE",
  authDomain: "notas-c012c.firebaseapp.com",
  projectId: "notas-c012c",
  storageBucket: "notas-c012c.firebasestorage.app",
  messagingSenderId: "452981411457",
  appId: "1:452981411457:web:f5ec7dcdafb1d2deb44780",
  measurementId: "G-0EEM4TQQJJ"
};

const appId = "app-estagios"; 
let app;
let db;

// Lógica de Inicialização Segura
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
  db = initializeFirestore(app, {
    experimentalForceLongPolling: true,
    ignoreUndefinedProperties: true
  });
} else {
  app = getApp();
  db = getFirestore(app);
}

// App Secundário de Notas
let appNotas;
try {
    appNotas = getApp("app-notas");
} catch (e) {
    appNotas = initializeApp(firebaseConfigNotas, "app-notas");
}
const db_notas = getFirestore(appNotas);

const auth = getAuth(app); 

// Caminhos das coleções
const basePath = `artifacts/${appId}/public/data`; 
export const paths = { 
  users: `${basePath}/users`,
  pelotoes: `${basePath}/pelotoes`,
  companhias: `${basePath}/companhias`,
  locais: `${basePath}/locais`,
  datasEstagio: `${basePath}/datasEstagio`,
  escolhas: `${basePath}/escolhas`,
  logs: `${basePath}/logs`,
  turmas: `${basePath}/turmas`, 
  escalasEncomendas: `${basePath}/escalas_encomendas`,
  aspirantometros: `${basePath}/aspirantometros`,
  relatoriosEstagio: `${basePath}/relatoriosEstagio`,
  professores: `${basePath}/professores`,
  materias: `${basePath}/materias`,
  livro_ordens: `${basePath}/livro_ordens`,
  cursos: `${basePath}/cursos`,
  queimogramas: `${basePath}/queimogramas`, 
  avaliacoesCiclos: `${basePath}/avaliacoesCiclos`,     
  avaliacoesRespostas: `${basePath}/avaliacoesRespostas`, 
  impedimentos: `${basePath}/impedimentos`, 
  cronogramas: `${basePath}/cronogramas`,
  
  // --- NOVOS CAMINHOS (ADICIONE ISTO) ---
  revistas_config: `${basePath}/revistas_config`,
  resultado_online: `${basePath}/resultado_online`,
  lideranca_pelotoes: `${basePath}/lideranca_pelotoes`
};

export { db, auth, db_notas };